import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { loadScriptsSequentially } from "../utils";
import "./LandingPage2.css";

// Importo le icone necessarie da react-icons (set FontAwesome)
import {
    FaShieldAlt,
    FaShoppingBag,
    FaHeadset,
    FaPercent,
    FaChartBar,
    FaRocket,
    FaUsers,
    FaGem,
    FaTimes,
    FaUser,
    FaHandPointer,
    FaVolumeUp,
    FaWifi
} from "react-icons/fa";

function TotemTouch() {
    const navigate = useNavigate();
    const formRef = useRef(null);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.huberway.org/assets/plugins/jquery/jquery-3.2.1.min.js?v=" + Date.now();
        script.onload = () => {
            loadScriptsSequentially([
                "js/pre-loader.js",
                "assets/bootstrap/js/popper.min.js",
                "assets/bootstrap/js/bootstrap.min.js",
                "js/parallaxie.js",
                "js/TweenMax.min.js",
                "js/jquery.wavify.js",
                "assets/wow/wow.min.js",
                "assets/counterup/jquery.counterup.min.js",
                "assets/counterup/jquery.waypoints.min.js",
                "js/main.js",
            ]);
        };
        document.body.appendChild(script);

        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []);

    const scrollToForm = () => {
        const offset = -20;
        if (formRef.current) {
            const formPosition = formRef.current.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top: formPosition + offset, behavior: "smooth" });
        }
    };

async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const payload = Object.fromEntries(formData);

    // 1. Validazione Campi Obbligatori
    if (!payload.NAME || !payload.NOMINATIVO || !payload.SHOP || !payload.PHONE || !payload.EMAIL || !payload.LUOGO) {
        alert("Per favore compila tutti i campi obbligatori.");
        return;
    }

    try {
        // 2. Invio della richiesta POST
        const response = await fetch("https://api.psicopatici.com/api/totem-candidature", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        if (response.ok) {
            // 3. Successo: Naviga alla thankspage
            console.log("Candidatura inviata con successo!");
            navigate("/thankspage");
        } else {
            // 4. Gestione Errore Server
            const errorData = await response.json().catch(() => ({}));
            console.error("Errore server:", errorData);
            alert("Si è verificato un errore durante l'invio. Riprova più tardi.");
        }
    } catch (error) {
        // 5. Gestione Errore di Rete
        console.error("Errore di rete:", error) ;
        alert("Errore di connessione. Controlla la tua rete e riprova.");
    }
}

    return (
        <div className="font-nunito bg-light text-dark">

            {/* =========================================
                1. NAVBAR & HERO SECTION
            ============================================= */}
            <section className="bg-black text-white position-relative overflow-hidden hero-section-wrapper" style={{ minHeight: "80vh" }}>
                <video
                    src="/video/vIDEO.mp4"
                    autoPlay loop muted playsInline
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{ objectFit: "cover", zIndex: 0 }}
                ></video>

                <div
                    className="position-absolute top-0 start-0 w-100 h-100 hero-overlay"
                    style={{ zIndex: 1 }}
                ></div>

                <div className="position-relative d-flex flex-column w-100" style={{ zIndex: 2, minHeight: "80vh" }}>\
                    <div style={{ marginTop: "30px" }} className="flex-grow-1 d-flex">
                        {/* mx-5 rimosso su mobile per evitare che il testo venga schiacciato, mantenuto mx-lg-5 per desktop */}
                        <div className="container px-3 px-lg-0 d-flex mx-lg-5">
                            <div className="row w-100 m-0">
                                <div className="col-lg-6 text-center text-lg-start d-flex flex-column pt-5 py-md-5">
                                    <div className="mt-4">
                                        <h1 className="fw-bold text-uppercase mb-3 hero-title-main">
                                            Trasforma <br /> la tua Boutique <br /> nel  <span className="text-brand-gold hero-title-main">Futuro del <br /> Fashion - Tech</span>
                                        </h1>
                                        <p className="lead mb-0 text-white hero-subtitle">
                                            Offri un'esperienza d'acquisto phygital, aumenta i<br className="d-none d-md-block" />
                                            margini e azzera le complicazioni logistiche.<br className="d-none d-md-block" />
                                            Innova la tua esperienza di vendita, elimina i rischi<br className="d-none d-md-block" />
                                            di magazzino e guadagna su ogni acquisto.
                                        </p>
                                    </div>

                                    <div className="mt-5 mt-lg-auto mb-4">
                                        <button className="btn bg-black text-white px-4 py-2 fw-semibold text-uppercase fs-5" onClick={scrollToForm}>
                                            CANDIDATI ORA
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* =========================================
                2. SEZIONE OPPORTUNITÀ
            ============================================= */}
            <section className="bg-white pt-5 pb-4 px-2 px-md-0">
                <div className="container pt-4 pb-4">

                    <div className="text-center mb-5">
                        <h2 className="fw-bold text-uppercase text-black title-secondary mb-1">Hai uno Store o uno Spazio Fisico?</h2>
                        <p className="lead text-black">Ospita il Totem touch di Psicopatici Italia in comodato d'uso gratuito</p>
                    </div>

                    <div className="d-flex align-items-center justify-content-center mb-3">
                        <div className="title-divider-line"></div>
                        <h5 className="text-uppercase mx-2 mx-md-4 mb-0 fw-bold text-vantaggi" style={{ color: '#555', letterSpacing: '1px' }}>I Vantaggi del Partner</h5>
                        <div className="title-divider-line"></div>
                    </div>

                    <div className="row g-4 mb-4">
                        <div className="col-md-4">
                            <div style={{ border: "2px solid #dac7b6" }} className="card w-100 h-100 text-center p-4 custom-card-border rounded-3 hover-lift shadow-none bg-brand-cream-light">
                                <FaShieldAlt className="display-1 text-brand-gold mb-3 mx-auto" />
                                <h5 style={{ fontSize: "19px", lineHeight: "1.2" }} className="fw-bold text-uppercase mb-0 text-black mb-3">Zero Rischi<br />Operativi</h5>
                                <p className="text-black small mb-0">Nessuna gestione logistica, merce invenduta o investimento iniziale.</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card w-100 h-100 text-center p-4 custom-card-border rounded-3 hover-lift shadow-none bg-brand-cream-light">
                                <FaShoppingBag className="display-1 text-brand-gold mb-3 mx-auto" />
                                <h5 style={{ fontSize: "19px", lineHeight: "1.2" }} className="fw-bold text-uppercase mb-0 text-black mb-3">Esperienza<br />Premium</h5>
                                <p className="text-black small mb-0">Shopping interattivo, fluido e moderno per i tuoi clienti.</p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card w-100 h-100 text-center p-4 custom-card-border rounded-3 hover-lift shadow-none bg-brand-cream-light">
                                <FaHeadset className="display-1 text-brand-gold mb-3 mx-auto" />
                                <h5 style={{ fontSize: "19px", lineHeight: "1.2" }} className="fw-bold text-uppercase mb-0 text-black mb-3">Supporto<br />Totale</h5>
                                <p className="text-black small mb-0">Assistenza tecnica dedicata e CRM in tempo reale per monitorare le vendite.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row g-4">
                        <div className="col-lg-7">
                            <div className="bg-brand-cream-semi-light rounded-3 p-4 p-md-5 h-100">
                                <h4 className="fw-bold text-uppercase mb-4 text-black text-md-start">Un modello win-win,<br />dove entrambi cresciamo.</h4>

                                <ul className="list-unstyled mb-0 d-flex flex-column gap-4">
                                    <li className="d-flex align-items-start justify-content-center">
                                        <div className="icon-circle-outline flex-shrink-0"><FaPercent /></div>
                                        <div className="text-start">
                                            <strong className="d-block text-uppercase mb-1 fw-bolder" style={{ fontSize: '0.95rem' }}>10% Commissione di Appartenenza:</strong>
                                            <span className="small text-black fw-medium">Su ogni acquisto del cliente nei 12 mesi successivi alla registrazione. Rinnovo automatico ad ogni acquisto.</span>
                                        </div>
                                    </li>
                                    <li className="d-flex align-items-start">
                                        <div className="icon-circle-outline flex-shrink-0"><FaChartBar /></div>
                                        <div className="text-start">
                                            <strong className="d-block text-uppercase mb-1 fw-bolder" style={{ fontSize: '0.95rem' }}>+20% Commissione di Vendita:</strong>
                                            <span className="small text-black fw-medium">Extra sul valore dell'acquisto effettuato direttamente dal tuo Totem.</span>
                                        </div>
                                    </li>
                                    <li className="d-flex align-items-start">
                                        <div className="icon-circle-outline flex-shrink-0"><FaRocket /></div>
                                        <div className="text-start">
                                            <strong className="d-block text-uppercase mb-1 fw-bolder" style={{ fontSize: '0.95rem' }}>Extra Boost:</strong>
                                            <span className="small text-black fw-medium">Fino al 12% in più integrando strategie di contenuti social.</span>
                                        </div>
                                    </li>
                                    <li className="d-flex align-items-start">
                                        <div className="icon-circle-outline flex-shrink-0"><FaUsers /></div>
                                        <div className="text-start">
                                            <strong className="d-block text-uppercase mb-1 fw-bolder" style={{ fontSize: '0.95rem' }}>Network:</strong>
                                            <span className="small text-black fw-medium">2% su ogni acquisto generato dai partner che hai invitato.</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-5 d-flex flex-column gap-3 bg-brand-cream-light">
                            <div className="d-flex align-items-center rounded-3 p-3 p-md-4">
                                <div className="icon-circle-filled mr-3 me-3 flex-shrink-0"><FaGem className="text-black" /></div>
                                <div className="text-start flex-grow-1">
                                    <strong className="d-block text-uppercase mb-1 fs-5">Chi Cerchiamo?</strong>
                                    <span style={{ fontSize: "14px" }} className="small text-black fw-bold">Boutique, concept store o showroom in ambito premium/luxury o multibrand di fascia medio-alta.</span>
                                </div>
                            </div>

                            <div className="d-flex align-items-center custom-card-border rounded-3 py-3 py-md-4 px-3 px-md-4">
                                <div className="icon-circle-outline-lg me-3 flex-shrink-0">
                                    <FaTimes className="text-muted" />
                                </div>
                                <div className="text-start flex-grow-1">
                                    <span style={{ fontSize: "14px" }} className="text-black fw-bolder">
                                        Non cerchiamo fast fashion, abbigliamento bambini, casual, intimo o sposa.
                                    </span>
                                </div>
                            </div>

                            <div className="d-flex align-items-center rounded-3 p-3 p-md-4 bg-brand-cream-semi-semi-light">
                                <div className="icon-circle-outline-lg border-dark mr-3 me-3 flex-shrink-0"><FaUser className="text-black" /></div>
                                <div className="text-start flex-grow-1">
                                    <span style={{ fontSize: "14px" }} className="small text-black fw-bold">Anche se non hai una boutique, puoi candidarti per ospitare il Totem e generare commissioni.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* =========================================
                3. SEZIONE: CUORE DIGITALE
            ============================================= */}
            <section className="bg-white pb-5 px-3 px-md-0">
                <div className="container pb-0 pt-5">

                    <div className="text-center mb-5">
                        <h2 className="fw-bold text-uppercase text-black title-secondary">Scopri il cuore digitale della tua boutique</h2>
                        <p className="text-muted" style={{ fontSize: "16px", fontWeight: "500" }}>
                            Disponibili in diverse dimensioni e configurazioni, si integrano perfettamente nel tuo store,<br className="d-none d-md-block" />
                            adattandosi al tuo stile e alle tue esigenze.
                        </p>
                    </div>

                    <div className="row align-items-start text-center mb-5 pb-4">
                        <div className="col-md-6 mb-5 mb-md-0">
                            <h3 className="mb-4 fw-bold title-tertiary totem-model-title">A Parete</h3>
                            <img src="img/totem/aparete.jpg" alt="Totem a Parete" className="img-fluid totem-img" />
                        </div>
                        <div className="col-md-6">
                            <h3 className="mb-4 fw-bold title-tertiary totem-model-title">Con Sostegno</h3>
                            <img src="img/totem/consupporto.jpg" alt="Totem con Sostegno" className="img-fluid totem-img" />
                        </div>
                    </div>

                    <div className="row align-items-end mt-5">
                        <div className="col-lg-5 text-start text-center text-lg-start">
                            <div className="mb-4">
                                <h4 className="fw-bold title-tertiary mb-0 spec-title">TOTEM 55”</h4>
                                <p className="text-muted m-0 spec-text">H: 1250 mm L: 722 mm P: 91 mm</p>
                            </div>

                            <div className="mb-4">
                                <h4 className="fw-bold title-tertiary mb-0 spec-title">TOTEM 65”</h4>
                                <p className="text-muted m-0 spec-text">H: 1522 mm L: 897 mm P: 63 mm</p>
                            </div>

                            <div className="mb-4">
                                <h4 className="fw-bold title-tertiary mb-0 spec-title">TOTEM 75”</h4>
                                <p className="text-muted m-0 spec-text">H: 1709 mm L: 1020 mm P: 88 mm</p>
                            </div>

                            <div className="mb-0">
                                <h4 className="fw-bold title-tertiary mb-0 spec-title">TOTEM 86”</h4>
                                <p className="text-muted m-0 spec-text">H: 1957 mm L: 1160 mm P: 99 mm</p>
                            </div>
                        </div>

                        <div className="col-lg-6 offset-lg-1 text-md-end text-center mt-5 mt-lg-0">
                            <p className="text-muted mb-4" style={{ fontSize: "16px", lineHeight: "1.8", fontWeight: "500" }}>
                                I nostri Totem Touch non sono semplici schermi,<br className="d-none d-md-block" />
                                ma veri e propri strumenti di vendita progettati<br className="d-none d-md-block" />
                                per trasformare ogni spazio fisico in un'esperienza<br className="d-none d-md-block" />
                                interattiva e coinvolgente.
                            </p>
                            <p className="text-muted m-0" style={{ fontSize: "16px", lineHeight: "1.8", fontWeight: "500" }}>
                                Dalla navigazione della collezione alla<br className="d-none d-md-block" />
                                personalizzazione dei capi, ogni dettaglio è<br className="d-none d-md-block" />
                                pensato per aumentare l'engagement dei clienti e<br className="d-none d-md-block" />
                                generare vendite senza limiti di stock.
                            </p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-5 text-start">
                            <div className="d-flex justify-content-between align-items-center border border-2 border-dark rounded-4 py-2 px-2 px-md-4 mt-4 mt-lg-5 mx-lg-0 icon-pill">
                                <div className="text-center pill-item">
                                    <FaHandPointer className="fs-2 text-dark mb-1" />
                                    <span className="d-block" style={{ fontSize: "9px", fontWeight: "700" }}>TOUCH SCREEN</span>
                                </div>
                                <div className="text-center border-start border-end border-2 border-dark px-2 px-md-4 pill-item">
                                    <FaVolumeUp className="fs-2 text-dark mb-1" />
                                    <span className="d-block" style={{ fontSize: "9px", fontWeight: "700" }}>AUDIO INTEGRATO</span>
                                </div>
                                <div className="text-center pill-item">
                                    <FaWifi className="fs-2 text-dark mb-1" />
                                    <span className="d-block" style={{ fontSize: "9px", fontWeight: "700" }}>CONNESSIONE WIFI</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* =========================================
                4. SEZIONE FORM
            ============================================= */}
            <section ref={formRef} className="py-5 px-3 px-md-0" style={{ backgroundColor: "#ffffff" }}>
                <div className="container pb-5 pt-0">

                    <div className="text-center mb-0">
                        <h2 className="fw-bold text-uppercase text-black title-secondary mb-3">
                            Candidature Aperte
                        </h2>
                        <p className="mx-auto text-form-desc" style={{ maxWidth: "700px", fontSize: "1.1rem", color: "#333", lineHeight: "1.5" }}>
                            Saranno selezionate soltanto 20 Boutique sul territorio nazionale <br className="d-none d-md-block" />
                            che riceveranno il Totem Touch Interattivo in <br />
                            <span className="fw-bold text-uppercase">Comodato d'uso gratuito!</span>
                        </p>
                    </div>

                    <div className="mx-auto bg-white p-0 pt-3 w-100"
                        style={{
                            maxWidth: "550px",
                            borderRadius: "8px",
                        }}>

                        <form className="w-100" onSubmit={handleSubmit}>
                            <div className="row g-4">
                                {[
                                    { id: "NAME", label: "Ragione Sociale" },
                                    { id: "NOMINATIVO", label: "Referente" },
                                    { id: "SHOP", label: "Nominativo Boutique" },
                                    { id: "LUOGO", label: "Indirizzo Boutique" },
                                    { id: "EMAIL", label: "Email", type: "email" },
                                    { id: "PHONE", label: "Recapito Telefonico", type: "tel" }
                                ].map((field) => (
                                    <div key={field.id} className="col-12 text-start mt-3">
                                        <label htmlFor={field.id} className="form-label fw-bold mb-1" style={{ fontSize: "14px", color: "#333" }}>
                                            {field.label} <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            id={field.id}
                                            name={field.id}
                                            type={field.type || "text"}
                                            className="form-control custom-input-style"
                                            style={{
                                                borderRadius: "4px",
                                                border: "1px solid #e0e0e0",
                                                padding: "12px",
                                                fontSize: "14px",
                                                backgroundColor: "#fff"
                                            }}
                                            required
                                        />
                                    </div>
                                ))}
                            </div>

                            <div className="mt-4">
                                <button type="submit"
                                    className="btn btn-dark w-100 py-3 fw-bold"
                                    style={{
                                        backgroundColor: "#000",
                                        border: "none",
                                        borderRadius: "4px",
                                        fontSize: "16px",
                                        letterSpacing: "0.5px",
                                        color: "white"
                                    }}>
                                    Invia
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>

            {/* FOOTER */}

        </div>
    );
}

export default TotemTouch;